import React from 'react';

import Skeleton from '..';

import { Container } from './styles';

function LiveShimmer() {
  return (
    <Container>
      <Skeleton className="dark" />
    </Container>
  );
}

export default LiveShimmer;
